import { flow } from 'fp-ts/function';
import { get, map, sortBy } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getOrEmptyArray, getOrEmptyObject, getStringProp } from '@mews/fp';

import { ApplicationState } from '../../../types';
import { WithCategoryId } from '../../../types/selectors/selectorPropTypes';

import { getEntities } from '../getEntities';
import { Entities } from '../types';
import { CategoryImageAssignment, CategoryImageAssignments, CategoryImageAssignmentsData } from './types';

const getCategoryImageAssignmentsEntity = createSelector<ApplicationState, Entities, CategoryImageAssignments>(
    getEntities,
    get('categoryImageAssignments')
);

const getCategoryImageAssignmentsData = createSelector(getCategoryImageAssignmentsEntity, getOrEmptyObject('data'));

const getCategoryImageAssignments = createSelector<
    ApplicationState,
    WithCategoryId,
    string,
    CategoryImageAssignmentsData,
    CategoryImageAssignment[]
>(getStringProp('categoryId'), getCategoryImageAssignmentsData, getOrEmptyArray);

const getSortedCategoryImageAssignments = flow(
    getCategoryImageAssignments,
    sortBy<CategoryImageAssignment>('ordering')
);
export const getSortedCategoryImageAssignmentsImageIds = flow(getSortedCategoryImageAssignments, map('imageId'));
